import request from '@/utils/request';
/**获取列表数据 */
export function grayscaleList(data) {
  return request.post('admin/grayscale/list', data);
}
export function addGrayscale(data) {
  return request.post('admin/grayscale/store', data);
}
export function delGrayscale(data) {
  return request.post('admin/grayscale/delete', data);
}